import { Reducer } from 'redux';
import { IAction } from '../types';
import { localKeyInfo } from '../config';
import LocalStore from '@/utils/store';

interface AnchorTipInfoJson {
  id?: string;
  type?: string;
  desc?: string;
  time: number;
}

/**
 * 直播模式信息
 * @property {number} micUserTime 麦序列表上下麦状态
 * @property {number} micUserInfo 麦序列表上下麦信息
 * @property {number} micContolTime 直播mic控放麦状态
 * @property {number} micContolState 直播mic控放麦信息
 * @property {number} micStopTime 直播mic允许停止上麦状态
 * @property {number} micStopState 直播mic允许停止上麦信息
 * @property {number} clearMicListState 清空直播麦序列表
 * @property {number} micSortTime 直播mic麦序调整状态
 * @property {any} micSortInfo 直播mic麦序调整信息
 * @property {number} emceeTime 直播mic主持人上下麦状态
 * @property {any} emceeInfo 直播mic主持人上下麦信息
 * @property {number} followTime 直播关注主播状态
 * @property {number} followState 直播关注主播信息 1 or -1
 * @property {number} voliceLiveHotTime 直播人气变动状态
 * @property {number} anchorTipTime 主播提醒状态
 * @property {AnchorTipInfoJson} anchorTipInfo 主播提醒信息
 * @property {number} banAnchorImgTime 主播禁画面状态
 * @property {string} banAnchorImgUrl 主播禁画面url
 * @property {number} banAnchorLiveTime 主播禁播状态
 * @property {any} banAnchorLiveInfo 主播禁播信息
 * @property {number} voiceAnchorhotTime 主播人气值变动状态
 * @property {any} voiceAnchorhotInfo 主播人气值变动信息
 */
export interface VoiceLiveInfoState {
  micUserTime: number;
  micUserInfo: any;
  micContolTime: number;
  micContolState: number;
  micStopTime: number;
  micStopState: number;
  clearMicListState: number;
  micSortTime: number;
  micSortInfo: any;
  emceeTime: number;
  emceeInfo: any;
  followTime: number;
  followState: number;
  voliceLiveHotTime: number;
  anchorTipTime: number;
  anchorTipInfo: AnchorTipInfoJson;
  banAnchorImgTime: number;
  banAnchorImgUrl: string;
  banAnchorLiveTime: number;
  banAnchorLiveInfo: any;
  voiceAnchorhotTime: number;
  voiceAnchorhotInfo: any;
}

const LOCALKEY = localKeyInfo.voiceLiveInfo;
const localVoiceInfo = LocalStore.getValue<VoiceLiveInfoState>(LOCALKEY) || {};

export const voiceLiveInfo: VoiceLiveInfoState = {
  micUserTime: 0,
  micUserInfo: null,
  micContolTime: 0,
  micContolState: 0,
  micStopTime: 0,
  micStopState: 0,
  clearMicListState: 0,
  micSortTime: 0,
  micSortInfo: null,
  emceeTime: 0,
  emceeInfo: null,
  followTime: 0,
  followState: 0,
  voliceLiveHotTime: 0,
  anchorTipTime: 0,
  anchorTipInfo: {
    time: 10
  },
  banAnchorImgTime: 0,
  banAnchorImgUrl: '',
  banAnchorLiveTime: 0,
  banAnchorLiveInfo: null,
  voiceAnchorhotTime: 0,
  voiceAnchorhotInfo: null,
  ...localVoiceInfo
};

export const setVoiceLiveInfo: (payload: VoiceLiveInfoState) => IAction<VoiceLiveInfoState> = (
  payload: VoiceLiveInfoState
) => ({
  type: 'setVoiceLiveInfo',
  payload
});

const voiceLiveInfoReducer: Reducer<VoiceLiveInfoState, IAction<any>> = (
  state = voiceLiveInfo,
  action: IAction<any>
) => {
  const { type, payload } = action;
  switch (type) {
    case 'setVoiceLiveInfo':
      LocalStore.setValue(LOCALKEY, payload);
      return {
        ...payload
      };
    default:
      return state;
  }
};

export default voiceLiveInfoReducer;
